import styled from '@emotion/styled';
import React from 'react';
import { assetUrl } from '~/helpers';
import { EmbedType } from '~/types/models';

export const ImageIcon = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

export const ColoredIconWrapper = styled.div`
  display: flex;
  text-align: center;
  background: #cdcdcd;
  color: #f2f2f2;
  border-radius: 5px;
  align-items: center;
  justify-content: center;

  ${ImageIcon} {
    max-width: 70%;
    max-height: 70%;
  }
`;

export const TransparentIconWrapper = styled.div`
  display: block;
  text-align: center;
`;

const useEmbeddedItemsInfo = () => {
  const getIcon = (iconPath: string, type: EmbedType) => {
    const icon = <ImageIcon src={assetUrl(iconPath)} />;

    switch (type) {
      case EmbedType.Video:
        return <ColoredIconWrapper>{icon}</ColoredIconWrapper>;
      case EmbedType.OEmbed: {
        return iconPath.includes('unknown-service.svg') ? (
          <ColoredIconWrapper>{icon}</ColoredIconWrapper>
        ) : (
          <TransparentIconWrapper>{icon}</TransparentIconWrapper>
        );
      }
    }
  };

  return { getIcon };
};

export default useEmbeddedItemsInfo;
